import { useState, useEffect } from "react";
import Breakpoints from "../../config/Breakpoints";
import styled from "styled-components";
import CoverTag from "./coverTag";
import EmptyImage from "../../atom/EmptyImage";

const Cover = ({sectionData, promoData, openAcceptAgreement, openLuckyNumbers}) => {
    const [imgSrcset, setImgSrcset] = useState([]);
    const [imgAlt, setImgAlt] = useState('');
    const [imgSrc, setImgSrc] = useState('');

    const CoverContainer = styled.div`
        ${CoverStyles}
    `;

    useEffect(() => {
        let srcSet = [];
        let smallImg = null;
        let largeImg = null;
        let defaultImg = null;
        let altText = '';

        sectionData.images.forEach((img, index) => {
            if(altText === null && img.description) {
                altText = img.description;
            }
            if(defaultImg === null && img.url) {
                defaultImg = img.url;
            }
            if(img.title.indexOf('__lg.') > -1) {
                largeImg = img.url;
            }
            if(img.title.indexOf('__sm.') > -1) {
                smallImg = img.url;
            }
        });

        if(smallImg !== null) {
            if(largeImg !== null) {
                srcSet.push({media: Breakpoints.md, srcset: largeImg});
            }
            defaultImg = smallImg;
        } else if(largeImg !== null) {
            defaultImg = largeImg;
        }

        setImgSrcset(srcSet);
        setImgAlt(altText);
        setImgSrc(defaultImg);
    },[sectionData.images]);

    return (
        <>
            <CoverContainer className="luckyNumber__cover">
                {imgSrc !== null && (
                    <picture>
                        {imgSrcset.map((item,index) => (
                            <source media={item.media} srcSet={item.srcset} key={`sourceset_${index}`} />
                        ))}
                        <img alt={imgAlt} src={imgSrc} />
                    </picture>
                )}
                {imgSrc == null && (
                    <EmptyImage />
                )}
                <CoverTag promoData={promoData} openAcceptAgreement={openAcceptAgreement} openLuckyNumbers={openLuckyNumbers} />
            </CoverContainer>
        </>
    );
}

export const CoverStyles = `
    & > .luckyNumber__cover {
        aspect-ratio: 16/7;
        border-radius: 1rem;
        width: 100%;
        height: auto !important;
        overflow: hidden;
    }

    & > .luckyNumber__cover > picture img {
        width: 100%;
        height: 100%;
        object-fit: contains;
    }

    @media ${Breakpoints.max.sm} {
        & > .luckyNumber__cover {
            aspect-ratio: 80/100;
        }
    }
    
    & > .luckyNumber__cover {
        position: relative;
        background: var(--color-xLightGray);
    }
`;

export default Cover;